import { render, staticRenderFns } from "./view-step.vue?vue&type=template&id=13d8f237&scoped=true"
import script from "./view-step.vue?vue&type=script&lang=js"
export * from "./view-step.vue?vue&type=script&lang=js"
import style0 from "./view-step.vue?vue&type=style&index=0&id=13d8f237&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8f237",
  null
  
)

export default component.exports